// removed by extract-text-webpack-plugin
module.exports = {"form":"login-poll__form__29zFI","form__field":"login-poll__form__field__3PJF6","form__link":"login-poll__form__link__3MXj2","form__subscribe-link":"login-poll__form__subscribe-link__K0_1y","form__container":"login-poll__form__container__2nmUB","form__subscribe":"login-poll__form__subscribe__3uFAu","form__information":"login-poll__form__information__2Dm0R","form__input":"login-poll__form__input__2EyxN","form__email":"login-poll__form__email__1M_Sq","form__text":"login-poll__form__text__oJr9m","button":"login-poll__button__3WDO2","error-email":"login-poll__error-email__2rcTI"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/time-poll/components/login-poll.scss
// module id = 1760
// module chunks = 1